import { render, staticRenderFns } from "./global-request-support.vue?vue&type=template&id=740a1768&scoped=true&"
import script from "./global-request-support.vue?vue&type=script&lang=js&"
export * from "./global-request-support.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "740a1768",
  null
  
)

export default component.exports